import { ReportChartFeedbackBaseType } from '@vision/ui/enums';
import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { FeedbackBasedQuestionBasedMeasureRenderer, TreeMapChart2CompareRenderer } from '../../components';
import { TreeMapChart2ValueComponent } from '../../components/ReportsDetailGraphicChartsRenderer/ReportsDetailGraphicChartsValueRenderer/TreeMapChart2ValueComponent';
import { DefaultReportChartThemeFont, extendDefaultChartValidationSchema } from '../default-chart.config';

export const TreeMapChart2DefaultConfiguration: ReportChartConfiguration = {
  validationSchema: extendDefaultChartValidationSchema({ withFeedbackBasedQuestionBased: true }),
  //measures: TreeMapChart2Measures,
  chartValueComponent: TreeMapChart2ValueComponent,
  measures: null,
  compareRendererComponent: TreeMapChart2CompareRenderer,
  compareHeader: {
    labelKey: 'page-reports:compare',
    showIcon: false,
  },
  measureHeader: {
    labelKey: 'page-reports:measurement',
    showIcon: false,
  },
  hideCompare: true,
  responseMultiple: true,
  measureRendererComponent: FeedbackBasedQuestionBasedMeasureRenderer,
  defaultFeedbackBasedQuestionBased: ReportChartFeedbackBaseType.FEEDBACK_BASED,
  customize: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    transactionalDate: {
      active: false,
    },
    feedbackCount: {
      active: false,
    },
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
  },
  defaultTheme: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      active: false,
      displayFormat: 'auto',
      roundingMethod: 'default',
      hideFormatPosition: true,
    },
  },
};
